<form id="parkerExtractForm" [formGroup]="form" autocomplete="off">
  <div class="d-lg-flex align-items-center mb-2">
    @if (allowClientSelection) {
      <app-client-autocomplete [(selectedClient)]="selectedClient" class="client-autocomplete me-2"></app-client-autocomplete>
    }
    @if (selectedClient || !allowClientSelection) {
      <div class="d-flex align-items-center">
        <label class="control-label required me-2">{{'i18n.domain.reports.filter.fields.month' | translate}}:</label>
        <ejs-datepicker #monthPicker
                        formControlName="month"
                        format="MMM yyyy"
                        class="me-2"
                        id="startDate"
                        [start]="calendarStart"
                        [depth]="calendarDepth">
        </ejs-datepicker>
      </div>
      @if (!authService.isUserStandardUser()) {
        <div class="d-flex align-items-center">
          <label class="control-label required me-2">{{'i18n.domain.reports.filter.fields.parker' | translate}}:</label>
          <app-autocomplete [getDataFunction]="searchParkerDropdownValues.bind(this)"
                            [(value)]="selectedParkerId"
                            [isFormComponent]="true"
                            placeholder="i18n.domain.reports.filter.fields.parker-dropdown-placeholder"
                            id="parkerId">
          </app-autocomplete>
        </div>
      } @else {
        <div class="d-flex align-items-center">
          <label class="control-label required me-2">{{'i18n.base.shared.client-dropdown.client' | translate}}:</label>
          <ejs-dropdownlist [dataSource]="clientParkerDropdownValues"
                            [fields]="keyValueDropdownSettings"
                            id="clientParker"
                            [showClearButton]="true"
                            formControlName="parkerId">
          </ejs-dropdownlist>
        </div>
      }
    }
  </div>
</form>
